@if (isAppReady) {
  <div class="page">
    @if (showHeader) {
      <app-responsive-header
        [isMobile]="isMobile()"
        [isUserLoggedIn]="isLoggedIn" />
    }
    <div
      class="page__container"
      [class.page__container--custom-mobile-layout]="isCustomMobileLayout()"
      [class.page__container--with-header]="showHeader || isHeaderScrolled"
      [class.page__container--with-mobile-menu]="showMobileMenu">
      @if (showExtraInfoHeader) {
        <extra-info-header />
      }
      <div
        class="page__container__wrapper"
        data-testid="menu-container-wrapper">
        @if (showDesktopMenu) {
          <app-lc-menu />
        }
        <main class="page__container__wrapper__content">
          <router-outlet />
        </main>
        @if (showContactSidebar) {
          <contact-sidebar />
        }
      </div>
    </div>
    @if (showMobileMenu) {
      <mobile-nav />
    }
  </div>
}
